import {
  HomeIcon,
  ListIcon,
  LogOutIcon,
  TicketIcon,
  UserIcon,
} from 'lucide-react'

import {
  PreferenceButton,
  PreferenceCategory,
  PreferenceLink,
  PreferenceScreen,
} from '../../components/Preference'
import { signOut, useMe } from '../../lib/auth-client'

function CogoLogo({ className }: { className?: string }) {
  return (
    <img
      src="/cogo-logo-mobile.svg"
      alt=""
      className={className}
      width={24}
      height={24}
      aria-hidden
    />
  )
}

export default function SettingsHome() {
  const { data: me } = useMe()

  async function logout() {
    await signOut()
    window.location.href = '/'
  }

  const accountSummary = me?.user?.isAnonymous
    ? 'Gastmodus'
    : me?.user?.name || me?.user?.email || 'Account'

  return (
    <PreferenceScreen title="Settings" backHref="/">
      <PreferenceCategory filled>
        <PreferenceLink
          icon={<UserIcon className="h-6 w-6" />}
          title="Account"
          summary={accountSummary}
          href="/settings/account"
        />
        <PreferenceLink
          icon={<HomeIcon className="h-6 w-6" />}
          title="Huishouden"
          summary={me?.tenant?.name || 'Naam wijzigen'}
          href="/settings/household"
        />
        <PreferenceLink
          icon={<CogoLogo className="h-6 w-6" />}
          title="Collect&Go"
          summary="Extensie, sync en artikel-verrijking"
          href="/settings/cogo"
        />
        <PreferenceLink
          icon={<ListIcon className="h-6 w-6" />}
          title="Lijsten"
          summary="Wishlist en favorieten beheren"
          href="/settings/lists"
        />
        <PreferenceLink
          icon={<TicketIcon className="h-6 w-6" />}
          title="Uitnodigingen"
          summary="Deel een link of QR met familie"
          href="/settings/invites"
        />
      </PreferenceCategory>

      <PreferenceCategory filled>
        <PreferenceButton
          icon={<LogOutIcon className="h-6 w-6" />}
          title="Uitloggen"
          onPress={logout}
          isDestructive
        />
      </PreferenceCategory>
    </PreferenceScreen>
  )
}
